module.exports = __webpack_public_path__ + "img/blog-cv-5.43e5900a.webp";